module.exports = __webpack_public_path__ + "img/instagram-sm.61c3aad9.svg";